import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-phone-feature-list',
  templateUrl: './phone-feature-list.component.html',
  styleUrls: ['./phone-feature-list.component.scss']
})
export class PhoneFeatureListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
